import { merge } from "lodash";
import addressModuleState from "./addressModule/state";
import shipmentModuleState from "./shipmentModule/state";
import carrierModuleState from "./carrierModule/state";

export default merge(addressModuleState, shipmentModuleState, carrierModuleState);
